<script>
    import Blur1 from "../svg/shapes/blurs/Blur1.svelte";
    import { appManager } from "../AppManagerStore";
    import { _ } from "svelte-i18n";
</script>

<section
    class="py-13 mt-n12"
    style="background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)), url({$appManager.PublicUrl}img/photos/gent-fietser.jpg); background-size: cover;">
    <div class="container pb-3 pb-mb-13">
        <div class="row justify-content-center">
            <div class="col-12 col-md-8 text-center">
                <h1 class="display-1 text-primary mb-6 mt-n3">
                    {$_("communicate.title.title")}
                </h1>
                <h3 class="display-3 text-white mb-6 mt-n3">
                    {$_("communicate.title.title2")}
                </h3>
                <p class="lead text-white mb-6 mb-md-8">
                    {$_("communicate.title.subtitle")}
                </p>

                <a
                    href="{$appManager.PublicUrl}contact"
                    target="_blank"
                    class="btn btn-primary me-1 lift">
                    {$_("communicate.title.start")}
                    <i class="fe fe-arrow-right ms-3" />
                </a>
                <a href="#explainer" class="btn btn-primary-soft lift">
                    {$_("communicate.title.learn")}
                </a>
            </div>
        </div>
    </div>
    <!-- <div class="container-fluid">
        <div
            class="row align-items-center justify-content-center overlay overlay-black overlay-50 mt-4">
            <div class="col-12 text-center client-logos">
                <a href="https://www.brussels.be/">
                    <img
                        src="{$appManager.PublicUrl}img/clients/stad-brussel.png"
                        alt="Brussel" /></a>
                <a href="https://stad.gent/nl">
                    <img
                        src="{$appManager.PublicUrl}img/clients/gent.png"
                        alt="Gent" /></a>
                <a href="https://www.mechelen.be/">
                    <img
                        src="{$appManager.PublicUrl}img/clients/stad-mechelen.png"
                        alt="Mechelen" /></a>
                <a href="https://www.izegem.be/">
                    <img
                        src="{$appManager.PublicUrl}img/clients/izegem.svg"
                        alt="Izegem" /></a>
            </div>
        </div>
    </div> -->
</section>

<style>
    .background {
    }
</style>
